import { createApp } from 'vue'
import { VueQueryPlugin } from '@tanstack/vue-query'
import '@/styles/app.css'
import App from './App.vue'
import { router } from './app/router'
import { i18n } from './lib/i18n'
import { queryClient } from './lib/query'
import { startSession } from './lib/auth'
import { startMotion } from './lib/motion'

// The animations' level is on the page before the first screen draws.
startMotion()

createApp(App)
  .use(i18n)
  .use(router)
  .use(VueQueryPlugin, { queryClient })
  .mount('#app')

void startSession()
